






























































































































import Vue, { PropType } from 'vue';
import {
  Exhibition,
  // exhibition as exhibitionM,
  Option,
  // options,
} from 'mostra';

export type DataType = {
  visitorTypes: Option
}

export default Vue.extend({
  name: 'admin-admin-exhibition-modify',
  data(): DataType {
    return {
      visitorTypes: [
        { value: 1, text: '黒背景白文字' },
        { value: 2, text: '白背景黒文字' },
      ],
    };
  },
  props: {
    exhibition: {
      type: Object as PropType<Exhibition>,
      required: true,
    },
    owner: {
      type: String as PropType<string>,
      required: true,
    },
  },
  computed: {
  },
  methods: {
  },
});
